import axios from "axios";
import { message } from "antd";
import {baseURL} from "../constants/index";

//创建实例
const service = axios.create({
  //   baseURL: process.env.REACT_APP_API,
  baseURL,
  timeout: 50000,
});

//请求拦截
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
//响应拦截
service.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.code == 200) {
      return response.data;
    } else {
      message.error(response.data.message);
    }
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default service;
